import Footer from 'components/Footers/Footer';
import Navbar from 'components/Navbars/AdminNavbar';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BASE_URL from 'components/BaseUrl/apiConfig';
import Swal from 'sweetalert2';
const EditUser = ({ location }) => {
    const history = useHistory();



    useEffect(() => {
        // Check if user is not logged in (localStorage is empty)
        if (!localStorage.getItem("userData")) {
            // Redirect to the login page
            history.push("/login");
        }
    }, [history]);


    const { user } = location.state;


    // State for form fields and validation
    const [formData, setFormData] = useState({
        fullname: user.fullName,
        name: user.userName,
        email: user.emailId,
        password: user.password,
    });

    // State for validation messages
    const [validationMessages, setValidationMessages] = useState({
        fullname: '',
        name: '',
        email: '',
        password: '',
    });



    // Function to handle form field changes
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData({ ...formData, [name]: value });

    // };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setValidationMessages((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the validation error when the user types
        }));
    };


    // Function to perform validation
    const validateForm = () => {
        let isValid = true;
        const newValidationMessages = {};

        // Full Name validation
        if (formData.fullname.trim() === '') {
            newValidationMessages.fullname = 'Full Name is required';
            isValid = false;
        }
        // Username validation
        if (formData.name.trim() === '') {
            newValidationMessages.name = 'Username is required';
            isValid = false;
        }
        // Password validation
        if (formData.password.trim() === '') {
            newValidationMessages.password = 'Password is required';
            isValid = false;
        }
        // Email validation
        if (formData.email.trim() === '') {
            newValidationMessages.email = 'Email is required';
            isValid = false;
        } else if (!isValidEmail(formData.email)) {
            newValidationMessages.email = 'Invalid email format';
            isValid = false;
        }

        setValidationMessages(newValidationMessages);
        return isValid;
    };


    // Function to check email format
    const isValidEmail = (email) => {
        // Add your email validation logic here
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleFormSubmit = () => {

        // Validate the form before making the API call
        if (!validateForm()) {
            return;
        }

        // Function to show SweetAlert confirmation
        const showConfirmation = () => {
            Swal.fire({
                title: 'Confirmation!',
                text: 'Are you sure want to update the user information.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: ' update',
                cancelButtonText: 'cancel',
            }).then((result) => {
                if (result.isConfirmed) {
                    // User clicked "Yes, update it!" - proceed with the fetch
                    if (validateForm()) {
                        fetch(`${BASE_URL}/api/Users/UpdateUser`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                userId: user.userId,
                                fullName: formData.fullname,
                                userName: formData.name,
                                emailId: formData.email,
                                password: formData.password,
                                // Add other fields as needed
                            }),
                        })
                            .then(response => response.json())
                            .then(data => {
                                if (data.success) {
                                    // SweetAlert for success
                                    Swal.fire({
                                        icon: 'success',
                                        title: 'Successfully!',
                                        text: 'The user information has been updated successfully.',
                                    }).then(() => {
                                        // Redirect or perform additional actions if needed
                                        console.log('User updated successfully:', data);
                                        history.goBack(); // Redirect back after successful update
                                    });
                                } else {
                                    // SweetAlert for failure
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'User Update Failed',
                                        text: data.msg || 'An error occurred while updating the user information.',
                                    }).then(() => {
                                        // Handle failure (e.g., show error message, additional actions, etc.)
                                        console.error('User update failed:', data.msg);
                                    });
                                }

                            })
                            .catch(error => console.error('Error updating user:', error));
                    }
                }
            });
        };

        // Call the showConfirmation function
        showConfirmation();
    };
    return (
        <>
            <Navbar />
            <div className="container mx-auto p-4 h-full">
                <div className="flex content-center items-center justify-center h-full">
                    <div className="w-full lg:w-6/12 px-4">
                        <div className="relative flex flex-col min-w-0 break-words w-full mb-3 shadow-lg rounded-lg bg-white border-0">
                            <div className="rounded-t mb-0 px-6 py-3">
                                <div className="text-center mb-3">
                                    <h1 className="text-2xl font-bold">
                                        Update User
                                    </h1>
                                </div>
                                {/* <div className="text-red-500 text-xs mt-1">
                                    {response_api}
                                </div> */}
                                {/* <hr className="mt-6 border-b-1 border-blueGray-300" /> */}
                            </div>
                            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                                <form>


                                    {/* Name Input */}
                                    <div className="relative w-full mb-3">
                                        <label
                                            className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                            htmlFor="fullname"
                                        >
                                            Full Name
                                        </label>
                                        <input
                                            type="text"
                                            id="fullname"
                                            name="fullname"
                                            value={formData.fullname}
                                            onChange={handleInputChange}
                                            className="border rounded w-full"
                                            placeholder="Full Name"
                                        />
                                        <div className="text-red-500 text-xs mt-1">
                                            {validationMessages.fullname}
                                        </div>
                                    </div>


                                    {/* Name Input */}
                                    <div className="relative w-full mb-3">
                                        <label
                                            className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                            htmlFor="name"
                                        >
                                            User Name
                                        </label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            className="border rounded w-full"
                                            placeholder="Username"
                                            disabled
                                        />
                                        <div className="text-red-500 text-xs mt-1">
                                            {validationMessages.name}
                                        </div>
                                    </div>

                                    {/* Email Input */}
                                    <div className="relative w-full mb-3">
                                        <label
                                            className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                            htmlFor="email"
                                        >
                                            Email
                                        </label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            className="border rounded w-full"
                                            placeholder="Email"
                                            disabled
                                        />
                                        <div className="text-red-500 text-xs mt-1">
                                            {validationMessages.email}
                                        </div>
                                    </div>


                                    {/* Email Input */}
                                    <div className="relative w-full mb-3">
                                        <label
                                            className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                            htmlFor="email"
                                        >
                                            Password
                                        </label>
                                        <input
                                            type="password"
                                            id="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            className="border rounded w-full"
                                            placeholder="Password"

                                        />
                                        <div className="text-red-500 text-xs mt-1">
                                            {validationMessages.password}
                                        </div>
                                    </div>

                                    {/* Buttons */}
                                    <div className="text-right mt-6 flex flex-row justify-end">
                                        <button
                                            type="button"
                                            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                            onClick={() => history.goBack()}
                                        >
                                            Back to users
                                        </button>
                                        <button
                                            className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={handleFormSubmit}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default EditUser;
